import { Injectable, signal } from '@angular/core';
import { MenuItem } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class MenuStateService {
  topbarItems = signal<MenuItem[]>([]);
  sidebarItems = signal<MenuItem[]>([]);
  configuratorItems = signal<MenuItem[]>([]);

  setTopbarItems(items: MenuItem[]): void {
    this.topbarItems.set(items);
  }

  setSidebarItems(items: MenuItem[]): void {
    this.sidebarItems.set(items);
  }

  setConfiguratorItems(items: MenuItem[]): void {
    this.configuratorItems.set(items);
  }
}
